import React from 'react';
import { makeCSS } from '../../../utils/makeCSS';
import { ShortCut } from '../../../../../ui/src/keyboard-shortcuts/ShortCut';
import { MenuItem } from '../MenuItem';

import { Color } from '../Color';
import { SizeVariants } from '../../../theme/themes';
import { IconName } from '../Icon';
import { RouteProps } from 'react-router-dom';
export interface NavItem {
  dataset?: {
    id: string;
    type: string;
    pathname?: string;
  };
  imagePath?: IconName;
  linkTitle: string;
  url?: string | RouteProps;
  shortcut?: string;
  active?: boolean;
  /** Modal name */
  modal?: string;
}

export interface NavItemProps {
  isActive: boolean;
  item: NavItem;
  onClick: () => void;
  quickNavigation?: boolean;
  /**failed status from the media queue to display a notification in the mobile menu icon */
  failedStatus?: boolean;
  isDropActive?: boolean;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    navigationRowSpacing: {
      paddingTop: '4px',
      paddingBottom: '4px',
      margin: 3, //prevent overlapping of the different containers
      border: `1px solid transparent`,
      borderRadius: theme.borderRadius.lg
    },
    dropActive: {
      borderColor: theme.color.background.primary
    }
  };
});

export const NavItem = (props: NavItemProps) => {
  const {
    isActive,
    isDropActive = false,
    item,
    onClick,
    quickNavigation,
    failedStatus
  } = props;
  const classes = useCSS();

  return (
    <div
      className={`${quickNavigation ?? classes.navigationRowSpacing} ${
        isDropActive ? classes.dropActive : ''
      }`}
      id={`tour-steps__${item.linkTitle}`}
      data-type={item.dataset?.type}
      data-id={item.dataset?.id}
      data-pathname={item.dataset?.pathname || item.url}
    >
      {item.shortcut && <ShortCut keyCode={item.shortcut} action={onClick} />}
      <MenuItem
        mobileVersion={quickNavigation}
        disabled={!item.url && !item.modal}
        onClick={onClick}
        itemIcon={item.imagePath}
        value={item.linkTitle}
        selected={item.linkTitle != 'Menu' ? isActive : false}
        disableSelected={item.linkTitle != 'Menu' ? false : true}
      />
      {quickNavigation && item.linkTitle === 'Menu' && (
        <>
          {failedStatus && (
            <div style={{ position: 'absolute', right: 40, top: 10 }}>
              <Color size={SizeVariants.sm} color="red" outlined={false} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
